export function utf8to16(str){
	let out, i, len, c;
	let char2, char3;
	out = "";
	len = unescape(str).length;
	i = 0;
	while(i < len) {
		 c = unescape(str).charCodeAt(i++);
		 switch(c >> 4)
		 { 
		   case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
			 out += unescape(str).charAt(i-1);
			 break;
		   case 12: case 13:
			 char2 = unescape(str).charCodeAt(i++);
			 out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
			 break;
		   case 14:
			 char2 = unescape(str).charCodeAt(i++);
			 char3 = unescape(str).charCodeAt(i++);
			 out += String.fromCharCode(((c & 0x0F) << 12) |
				((char2 & 0x3F) << 6) |
				((char3 & 0x3F) << 0));
			 break;
		 }
	}
	return out;
}



// WEBPACK FOOTER //
// ./src/utils/utf8to16.js